import type { ElementType } from "react";
// Path imports, deliberately. `import * as Icons from "@mui/icons-material"`
// plus a dynamic `Icons[name]` lookup defeats tree-shaking and ships the entire
// ~2,000-icon package in this single-bundle app (verified: SportsRugby was in
// the built main.js). Path imports keep only what is listed here.
import BadgeOutlined from "@mui/icons-material/BadgeOutlined";
import BusinessOutlined from "@mui/icons-material/BusinessOutlined";
import CampaignOutlined from "@mui/icons-material/CampaignOutlined";
import CircleOutlined from "@mui/icons-material/CircleOutlined";
import FolderSharedOutlined from "@mui/icons-material/FolderSharedOutlined";
import GroupOutlined from "@mui/icons-material/GroupOutlined";
import InsightsOutlined from "@mui/icons-material/InsightsOutlined";
import Inventory2Outlined from "@mui/icons-material/Inventory2Outlined";
import ReceiptLongOutlined from "@mui/icons-material/ReceiptLongOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import TrendingUpOutlined from "@mui/icons-material/TrendingUpOutlined";
import UploadFileOutlined from "@mui/icons-material/UploadFileOutlined";

/**
 * Every icon name `navigation.ts` declares, resolved to its component. Lives
 * beside the nav tables because they are two halves of one contract: an item's
 * `icon` string means nothing unless it has an entry here — the rail renders
 * `NAV_ICONS[name] ?? NAV_ICON_FALLBACK`, so a missing entry silently draws a
 * plain circle. Add the path import and the entry when adding a nav item.
 */
export const NAV_ICONS: Record<string, ElementType> = {
  BadgeOutlined,
  BusinessOutlined,
  CampaignOutlined,
  FolderSharedOutlined,
  GroupOutlined,
  InsightsOutlined,
  Inventory2Outlined,
  ReceiptLongOutlined,
  SchoolOutlined,
  TrendingUpOutlined,
  UploadFileOutlined,
};

export const NAV_ICON_FALLBACK: ElementType = CircleOutlined;
